import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary, grayIconFill } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	actions: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-end',
		// Pin to the bottom so cards in a row line up regardless of how many lines the title takes.
		marginTop: 'auto',
		// Match the card's own 24px padding so the gap above the buttons equals the gap below them.
		paddingTop: THEME.spacing.lg,
	},
	caretButton: {
		paddingLeft: THEME.spacing.sm,
		paddingRight: THEME.spacing.sm,
	},
	bookingMenu: {
		width: 136,
	},
	categoryPill: {
		display: 'inline-flex',
		marginLeft: THEME.spacing.sm,
	},
	clockContainer: {
		alignItems: 'center',
		display: 'flex',
		paddingTop: 6,
	},
	clockIcon: {
		marginRight: 6,
	},
	clockText: {
		color: grayIconFill,
	},
	container: {
		backgroundColor: THEME.colors.background.light,
		boxShadow: `0 0 6px 0 rgba(139, 139, 139, 0.20)`,
		// Column layout lets the action row sit at the bottom of a stretched card.
		display: 'flex',
		flexDirection: 'column',
		padding: '24px 24px',
		position: 'relative',
		borderRadius: 8,
	},
	description: {
		paddingTop: THEME.spacing.xs,
	},
	header: {
		color: brandPrimary,
		margin: 0,
	},
	unpublished: {
		color: grayIconFill,
		fontSize: THEME.typography.fontSizes.sm,
	},
	moreMenu: {
		position: 'absolute',
		right: 16,
		top: 10,
	},
});
